module.exports = __webpack_public_path__ + "img/sigleblack.c3d6e6a8.png";